import React from 'react';

const InputFloatLabel = ({
    value,
    onChange,
    labelText,
    labelClass = '',
    name,
    className = '',
    placeholder = ' ', 
    type = 'text',
    id,
    ...props
}) => {
    return (
        <div className="relative">
            <input
                type={type}
                name={name}
                id={id}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                {...props}
                className={`peer h-10 w-full border-b-2 outline-none px-2 border border-gray-400 rounded focus:border-blue-500 focus:outline-none ${className}`}
            />
            <label
                htmlFor={id}
                className={`absolute left-2 -top-3.5 text-sm text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-focus:-top-3.5 peer-focus:text-sm peer-focus:text-blue-500 ${labelClass}`}
            >
                {labelText}
            </label>
        </div>
    );
};

export default InputFloatLabel;
